var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKreis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.00 400.00",
    "data-guides": "{\"vertical\":[],\"horizontal\":[]}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("ellipse", {
    fill: "transparent",
    fillOpacity: 1,
    stroke: "#ee5622",
    strokeOpacity: 1,
    strokeWidth: 50,
    id: "tSvg14915421621",
    title: "Ellipse 1",
    cx: 200,
    cy: 200,
    rx: 150,
    ry: 150,
    style: {
      transform: "rotate(0deg)",
      transformOrigin: "200px 200px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreis);
export default __webpack_public_path__ + "static/media/kreis.311a3088b951f628fbd57dc2799041f4.svg";
export { ForwardRef as ReactComponent };